export default "/images/9ef6e34a1601860cc1528cb92d2b495b.jpg";